import { render } from "./Static.vue?vue&type=template&id=786fa803&ts=true"
import script from "./Static.vue?vue&type=script&lang=ts"
export * from "./Static.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__